export enum Permission {
  ADMIN = 1,
  REDAKTEUR = 2,
  FREIGEBER = 3,
  SUPER_ADMIN = 4,
}

export const PermissionLabel: Record<Permission, string> = {
  [Permission.ADMIN]: 'Admin',
  [Permission.REDAKTEUR]: 'Redakteur',
  [Permission.FREIGEBER]: 'Freigeber',
  [Permission.SUPER_ADMIN]: 'Super Admin',
};

/**
 * The roles a user may hand out, as options for the role select.
 *
 * Super Admin is only offered to a Super Admin: the backend refuses the grant
 * from anyone else, so showing it to a normal admin only produces a failed
 * save. The Scala UI never offered it at all — that role was set directly in
 * the database.
 */
export const assignablePermissions = () =>
  Object.entries(PermissionLabel)
    .filter(([id]) => Number(id) !== Permission.SUPER_ADMIN)
    .map(([id, title]) => ({ id, title }));
